import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateInvoiceTaxAuthorityConfig } from 'Services/invoices';

export default function useUpdateInvoiceTaxAuthorityConfig() {
    const queryClient = useQueryClient();

    const { mutateAsync, isPending } = useMutation({
        mutationFn: ({ configId, params }) => updateInvoiceTaxAuthorityConfig(configId, params),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['invoices', 'tax-authority-configs'] });
        },
    });

    return { updateConfig: mutateAsync, isPending };
}
